// Video grid interaction
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".video-item").forEach((item) => {
        item.addEventListener("mouseenter", () => {
            const video = item.querySelector("video");
            if (video) video.play();
        });

        item.addEventListener("mouseleave", () => {
            const video = item.querySelector("video");
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        });
    });
});

// Make selectCharacter function globally accessible
window.selectCharacter = function (characterId) {
    // Redirect to the lab page with the character ID
    window.location.href = `/lab?character=${characterId}`;
};

/**
 * Legend Explorer with advanced filtering, search and pagination
 */
document.addEventListener("DOMContentLoaded", function () {
    // Define the array of legends (historical figures)
    const legends = [
        {
            id: "ec6c5b20-8ac6-42bd-b291-f248cb3f0ebc",
            name: "Felix Klein",
            tagline: "Master of symmetry and groups",
            image: "/static/images/FelixKlein.png",
            field: "Mathematics",
        },
        {
            id: "8f67d579-41c2-456d-900b-fccbcbf46bd3",
            name: "François Viète",
            tagline: "Father of symbolic algebra",
            image: "/static/images/FrancoisViete.png",
            field: "Mathematics",
        },
        {
            id: "d13b5a81-ed77-4a25-8a01-a76a0165b349",
            name: "Archimedes",
            tagline: "Give Me a Place to Stand",
            image: "/static/images/Archimedes.png",
            field: "Mathematics",
        },
        {
            id: "e97568c5-1daa-4a95-b4ae-0fe374c6b083",
            name: "Marcus Aurelius",
            tagline: "The philosopher on the throne",
            image: "/static/images/MarcusAurelius.png",
            field: "Leadership",
        },
        {
            id: "c4b9ac58-a66a-451e-b035-afabd8be50b9",
            name: "Aristotle",
            tagline: "The walking teacher",
            image: "/static/images/Aristotle.png",
            field: "Philosophy",
        },
        {
            id: "ece0ab37-37c1-4ead-8222-fbb5b185dbe2",
            name: "Alessandro Volta",
            tagline: "Inventor of the battery",
            image: "/static/images/AlessandroVolta.png",
            field: "Science",
        },
        {
            id: "c73fed54-81e3-46ec-9d7c-3d11d05b142d",
            name: "Eratosthenes",
            tagline: "He Measured the Earth",
            image: "/static/images/Eratosthenes.png",
            field: "Science",
        },
        {
            id: "3140d634-c7ca-4bda-af36-e1b49978b201",
            name: "Thomas Bayes",
            tagline: "The Reverend of Belief",
            image: "/static/images/ThomasBayes.png",
            field: "Mathematics",
        },
        {
            id: "e3428624-bd1e-48b9-ae8c-c66ba68879cc",
            name: "George Boole",
            tagline: "Logic made arithmetic",
            image: "/static/images/GeorgeBoole.png",
            field: "Mathematics",
        },
        {
            id: "ca6ebdca-5151-4a58-8523-56d25fce5dfa",
            name: "William Playfair",
            tagline: "The father of statistical graphics",
            image: "/static/images/WilliamPlayfair.png",
            field: "Science",
        },
        {
            id: "78376372-3d71-4fce-8650-82b5be2c006b",
            name: "Diophantus",
            tagline: "Father of Algebra",
            image: "/static/images/Diophantus.png",
            field: "Mathematics",
        },
        {
            id: "a2a43496-9a83-4444-813e-18a1930296e6",
            name: "Omar Khayyam",
            tagline: "Geometer of Wine and Time",
            image: "/static/images/OmarKhayyam.png",
            field: "Mathematics",
        },
        {
            id: "e617290b-bda0-4771-91ac-3fe6939dd412",
            name: "Benjamin Franklin",
            tagline: "Printer, sage, and founder",
            image: "/static/images/BenjaminFranklin.png",
            field: "Leadership",
        },
        {
            id: "2707ca40-df64-4258-97c8-67d3695e8a42",
            name: "Brahmagupta",
            tagline: "Master of Zero",
            image: "/static/images/Brahmagupta.png",
            field: "Mathematics",
        },
        {
            id: "5a39bed2-a551-4a03-98a2-46104a3324bf",
            name: "Leonhard Euler",
            tagline: "The Master of Us All",
            image: "/static/images/LeonhardEuler.png",
            field: "Mathematics",
        },
        {
            id: "c93478a1-ed2f-4f1a-81f6-3fa474a21566",
            name: "Joseph-Louis Lagrange",
            tagline: "The Analyst Without Diagrams",
            image: "/static/images/JosephLouisLagrange.png",
            field: "Mathematics",
        },
        {
            id: "94b6efbe-0aaa-47c7-bd3f-6d4f441d767f",
            name: "Grace Hopper",
            tagline: "Admiral of the compiler",
            image: "/static/images/GraceHopper.png",
            field: "Engineering",
        },
        {
            id: "127cd993-f16e-4659-84fa-882cba633097",
            name: "Galileo Galilei",
            tagline: "Father of Modern Science",
            image: "/static/images/GalileoGalilei.png",
            field: "Science",
        },
        {
            id: "7f61d092-99e4-48e6-bf80-7aa2b7bd98ff",
            name: "Carl Friedrich Gauss",
            tagline: "The Prince of Mathematicians",
            image: "/static/images/CarlFriedrichGauss.png",
            field: "Mathematics",
        },
        {
            id: "c0063a05-916b-45d0-bc2c-c63210414b17",
            name: "Ada Lovelace",
            tagline: "Enchantress of numbers",
            image: "/static/images/AdaLovelace.png",
            field: "Mathematics",
        },
        {
            id: "3841a6bb-f977-453d-92f5-6cec1267546f",
            name: "Sigmund Freud",
            tagline: "Explorer of the hidden mind",
            image: "/static/images/SigmundFreud.png",
            field: "Science",
        },
        {
            id: "14836d13-ace6-4bf8-be26-26fbb80ed9bc",
            name: "Socrates",
            tagline: "The barefoot questioner",
            image: "/static/images/Socrates.png",
            field: "Philosophy",
        },
        {
            id: "6bcf3678-e232-46c9-996a-67beb3fd2dbf",
            name: "Al-Khwarizmi",
            tagline: "The Man Who Balanced Equations",
            image: "/static/images/AlKhwarizmi.png",
            field: "Mathematics",
        },
        {
            id: "191e6103-a42c-4132-926c-230e7b1be5b6",
            name: "Jacob Bernoulli",
            tagline: "The Reckoner of Odds",
            image: "/static/images/JacobBernoulli.png",
            field: "Mathematics",
        },
        {
            id: "5802e813-e715-491d-a0fd-92dc643c458e",
            name: "Blaise Pascal",
            tagline: "Prodigy of Reason and Faith",
            image: "/static/images/BlaisePascal.png",
            field: "Mathematics",
        },
        {
            id: "f9f3f836-00c6-4160-8416-4b71b53f1307",
            name: "Srinivasa Ramanujan",
            tagline: "The man who knew infinity",
            image: "/static/images/SrinivasaRamanujan.png",
            field: "Mathematics",
        },
        {
            id: "7021ffd6-51bb-41a8-920e-935899dcd631",
            name: "Isaac Newton",
            tagline: "Architect of Physics",
            image: "/static/images/Newton.png",
            field: "Physics",
        },
        {
            id: "d537d61d-0313-421b-ae66-48a8d7222b3f",
            name: "Nikola Tesla",
            tagline: "Electric Visionary",
            image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Tesla_circa_1890.jpeg/300px-Tesla_circa_1890.jpeg",
            field: "Engineering",
        },
        {
            id: "5eb1ad8d-4c11-4174-b79a-c232991d015b",
            name: "J. Robert Oppenheimer",
            tagline: "Brilliance with Consequence",
            image: "/static/images/Oppenheimer.png",
            field: "Physics",
        },
        {
            id: "7c7ac397-c36e-4218-92d4-f437d1959cca",
            name: "Euclid",
            tagline: "Father of Geometry",
            image: "/static/images/Euclid.png",
            field: "Mathematics",
        },
        {
            id: "bc5d31a8-047b-4f72-8f16-fea7a365ca69",
            name: "Richard Feynman",
            tagline: "Quantum Visionary",
            image: "/static/images/RichardFeynman.png",
            field: "Science",
        },
        {
            id: "1a35136c-42d8-46c7-a189-c4b32da87832",
            name: "John Neumann",
            tagline: "Architect of Computation",
            image: "/static/images/JohnNeumann.png",
            field: "Science",
        },
        {
            id: "be0dcf0f-c72b-48f7-a462-6ba7560498d7",
            name: "Alan Turing",
            tagline: "Architect of Computation",
            image: "/static/images/Alan.png",
            field: "Science",
        },
        {
            id: "16f5b6a1-45f6-4c01-a612-60d4e4ab2297",
            name: "René Descartes",
            tagline: "Father of Modern Philosophy",
            image: "/static/images/ReneDescartes.png",
            field: "Philosophy",
        },
        {
            id: "93ea7051-9722-443d-90fb-18a84c51894c",
            name: "James Clerk Maxwell",
            tagline: "Master of Light",
            image: "/static/images/JamesClerk.png",
            field: "Science",
        },
        {
            id: "01db85dc-81e0-4433-9440-a54ce4976178",
            name: "Erwin Schrodinger",
            tagline: "Quantum Explorer",
            image: "/static/images/Erwin.png",
            field: "Science",
        },
        {
            id: "2db1d398-0161-46cd-8aff-53008d29a9dc",
            name: "Claude Shannon",
            tagline: "Information Pioneer",
            image: "/static/images/Claude.png",
            field: "Science",
        },
        {
            id: "c2cc71ce-89e7-4c94-9441-eec86ec67a60",
            name: "Napoleon Bonaparte",
            tagline: "Master of Strategy",
            image: "/static/images/Napoleon.png",
            field: "Leadership",
        },
        {
            id: "0c6099ed-c0db-4dd7-bc46-1d720324db5a",
            name: "Michael Faraday",
            tagline: "Master of Electricity",
            image: "/static/images/Michael.png",
            field: "Science",
        },
        {
            id: "897eb00c-4f16-4f73-81d5-d1c91fad53f2",
            name: "Charles Darwin",
            tagline: "Father of Evolution",
            image: "/static/images/logo.png",
            field: "Science",
        },

        {
            id: "73f610bf-d9c9-4d9f-a026-a10086a66725",
            name: "Marie Curie",
            tagline: "Pioneer of Radioactivity",
            image: "/static/images/MarieCurie.png",
            field: "Science",
        },
        {
            id: "8944783c-2e2b-4796-b92e-21dacca776bc",
            name: "Leonardo da Vinci",
            tagline: "Renaissance Genius",
            image: "/static/images/DaVinci.png",
            field: "Arts",
        },
        {
            id: "b20dc26f-8924-4aee-9ef5-9b98c0367a34",
            name: "Ernest Hemingway",
            tagline: "Master of Minimalism",
            image: "/static/images/Hemingway.png",
            field: "Arts",
        },
        {
            id: "278dddd6-b4a8-4303-a41d-be6219dbc907",
            name: "Albert Einstein",
            tagline: "Relativity Revolutionary",
            image: "/static/images/Einstein.png",
            field: "Science",
        },
        {
            id: "d6e3a3f1-d31e-4aab-8dd0-8b820932bd13",
            name: "Enrico Fermi",
            tagline: "Nuclear Physicist",
            image: "/static/images/Fermi.png",
            field: "Science",
        },
        {
            id: "770e2d93-a6a4-41ed-aca1-8951327885b5",
            name: "Amelia Earhart",
            tagline: "Aviation Pioneer",
            image: "/static/images/Amelia.png",
            field: "Science",
        },
        {
            id: "031f2eea-64e5-441d-a37d-03d260cc43dc",
            name: "Abraham Lincoln",
            tagline: "Great Emancipator",
            image: "/static/images/Lincoln.png",
            field: "Leadership",
        },
        {
            id: "44f87c0b-ca22-4225-9fea-8d823e6a0160",
            name: "Warren Buffett",
            tagline: "Investment Sage",
            image: "/static/images/Warren Buffett.png",
            field: "Leadership",
        },
        {
            id: "5a16ff56-6e03-414e-a89d-cda9d83fae60",
            name: "Henry Ford",
            tagline: "Industry Pioneer",
            image: "/static/images/HenryFord.png",
            field: "Leadership",
        },
        {
            id: "581e7293-43cf-45ea-9fb3-0955c563cbe2",
            name: "Genghis Khan",
            tagline: "Empire Builder",
            image: "/static/images/GenghisKhan.png",
            field: "Leadership",
        },
        {
            id: "4f50a698-6034-49c1-b9d4-221f59bf2378",
            name: "Frida Kahlo",
            tagline: "Painter of the Soul",
            image: "/static/images/Frida.png",
            field: "Arts",
        },
        {
            id: "91d5cec5-1c21-423f-bbb4-bceb0f77a6c9",
            name: "Nostradamus",
            tagline: "The Seer of Provence",
            image: "/static/images/Nostradamus.png",
            field: "Philosophy",
        },
        {
            id: "88c314c4-5890-4e55-9418-8b46a376ef81a",
            name: "Friedrich Nietzsche",
            tagline: "Moral Rebel",
            image: "/static/images/Nietzsche.png",
            field: "Philosophy",
        },
        {
            id: "802bd089-d231-4c4e-830c-476199321af8",
            name: "Niels Bohr",
            tagline: "Atomic Architect",
            image: "/static/images/NielsBohr.png",
            field: "Science",
        },
        {
            id: "b8951237-698b-42b5-8b6e-ee381b91fb65",
            name: "Confucius",
            tagline: "Ethical Philosopher",
            image: "/static/images/Confusius.png",
            field: "Philosophy",
        },
        {
            id: "3f14429d-b2d4-4b99-8a05-58eed567c0d3",
            name: "Mansa Musa",
            tagline: "Wealthiest Emperor",
            image: "/static/images/Mansa Musa.png",
            field: "Leadership",
        },
        {
            id: "5a42d57c-6e2b-4ba8-bd32-838a1a5c5e6b",
            name: "Niccolo Machiavelli",
            tagline: "Renaissance Political Theorist",
            image: "/static/images/Machiavelli.png",
            field: "Philosophy",
        },
        {
            id: "992e9007-b4f8-4711-80c2-884daf3d9960",
            name: "Van Gogh",
            tagline: "Post-Impressionist Painter",
            image: "/static/images/Van Gogh.png",
            field: "Arts",
        },
        {
            id: "d75e63e0-2b2b-43ef-933f-589e8d6818c0",
            name: "Salvador Dali",
            tagline: "Surrealist Master",
            image: "/static/images/SalvadorDali.png",
            field: "Arts",
        },
        {
            id: "59c67a42-8c1e-45b8-aa41-b6fe6b3f5629",
            name: "George Orwell",
            tagline: "Visionary Author",
            image: "/static/images/Orwell.png",
            field: "Arts",
        },
        {
            id: "3542f19e-4e07-4828-8f9d-f330e4d6d660",
            name: "Plato",
            tagline: "Foundational Philosopher",
            image: "/static/images/Plato.png",
            field: "Philosophy",
        },
        {
            id: "d0c97034-328e-4538-8107-a9825d0c1594",
            name: "Martin Luther King Jr.",
            tagline: "Dreamer of a Just America",
            image: "/static/images/MartinLutherKing.png",
            field: "Civil Rights",
        },
        {
            id: "2baa0479-7e38-4473-a2f2-1ad54149dbac",
            name: "Muhammad Ali",
            tagline: "Boxing Legend",
            image: "/static/images/Ali.png",
            field: "Sports",
        },
        {
            id: "e3f55c33-3ff0-471f-b833-b59d7b145fc6",
            name: "Al Capone",
            tagline: "Notorious Gangster",
            image: "/static/images/AlCapone.png",
            field: "Crime",
        },
        {
            id: "4d7d2e17-b818-4144-b78b-629c688a71ac",
            name: "Karl Marx",
            tagline: "Father of Communism",
            image: "/static/images/Marx.png",
            field: "Economics",
        },
        {
            id: "a59fe2c1-9046-405a-9a99-a7ddbaee13be",
            name: "Adam Smith",
            tagline: "Father of Economics",
            image: "/static/images/AdamSmith.png",
            field: "Economics",
        },
    ];

    // Get references to DOM elements
    const search = document.getElementById("legend-search");
    const tags = document.querySelectorAll(".tag");
    const grid = document.getElementById("legend-grid");
    const loadMoreBtn = document.getElementById("load-more");

    // State variables
    const initialDisplayCount = 9; // Initial number of items to display
    let displayed = initialDisplayCount;

    // Create an elegant toggle button container
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "toggle-button-container";
    buttonContainer.style.display = "flex";
    buttonContainer.style.justifyContent = "center";
    buttonContainer.style.marginTop = "30px";
    buttonContainer.style.position = "relative";

    // Create a single toggle button with icons
    const toggleButton = document.createElement("button");
    toggleButton.className = "toggle-view-button";
    toggleButton.id = "toggle-view";
    toggleButton.innerHTML =
        '<span>Show More</span> <i class="fas fa-chevron-down"></i>';
    toggleButton.style.position = "relative";
    toggleButton.style.padding = "10px 20px";
    toggleButton.style.borderRadius = "30px";
    toggleButton.style.backgroundColor = "#3a4149";
    toggleButton.style.color = "white";
    toggleButton.style.border = "none";
    toggleButton.style.outline = "none";
    toggleButton.style.cursor = "pointer";
    toggleButton.style.fontWeight = "bold";
    toggleButton.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
    toggleButton.style.transition = "all 0.3s ease";

    // Add hover effect
    toggleButton.onmouseover = () => {
        toggleButton.style.backgroundColor = "#3a4149";
        toggleButton.style.transform = "translateY(-2px)";
        toggleButton.style.boxShadow = "0 6px 8px rgba(0, 0, 0, 0.12)";
    };

    toggleButton.onmouseout = () => {
        toggleButton.style.backgroundColor = "#3a4149";
        toggleButton.style.transform = "translateY(0)";
        toggleButton.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
    };

    // Replace Load More button with the container and add the toggle button
    // Check if loadMoreBtn exists before accessing its parentNode
    if (loadMoreBtn && loadMoreBtn.parentNode) {
        loadMoreBtn.parentNode.replaceChild(buttonContainer, loadMoreBtn);
    } else {
        // If loadMoreBtn doesn't exist, append the buttonContainer directly to the grid's parent
        if (grid && grid.parentNode) {
            grid.parentNode.appendChild(buttonContainer);
        }
    }
    buttonContainer.appendChild(toggleButton);

    // Flag to track if we're showing more or less
    let showingMore = false;

    // Initialize the grid on page load with the first 9 legends and add smooth animation
    if (grid) {
        grid.style.transition = "opacity 0.5s ease, transform 0.5s ease";
        renderLegends(legends.slice(0, displayed));
    }

    // Show toggle button if there are more legends than initially displayed
    if (legends.length <= displayed) {
        toggleButton.style.display = "none";
    }

    // Handle search input with debounce for better performance
    let searchTimeout;
    if (search) {
        search.addEventListener("input", () => {
            // Clear any existing timeout
            clearTimeout(searchTimeout);

            // Set a debounce timeout to avoid excessive rendering during fast typing
            searchTimeout = setTimeout(() => {
                // Save current scroll position relative to the grid
                const gridTopRelativeToViewport =
                    grid.getBoundingClientRect().top;

                const query = search.value.toLowerCase();
                const filtered = legends.filter(
                    (l) =>
                        l.name.toLowerCase().includes(query) ||
                        l.field.toLowerCase().includes(query),
                );

                // Apply fade out effect before updating content
                grid.style.opacity = "0";
                grid.style.transform = "translateY(20px)";

                setTimeout(() => {
                    // Reset to initial count when searching
                    if (search.value.trim() !== "") {
                        displayed = initialDisplayCount;
                        showingMore = false;
                    }

                    renderLegends(filtered.slice(0, displayed));

                    // Fade in the new content
                    grid.style.opacity = "1";
                    grid.style.transform = "translateY(0)";

                    // Update toggle button visibility and state
                    if (filtered.length > displayed) {
                        toggleButton.style.display = "block";
                        toggleButton.innerHTML =
                            '<span>Show More</span> <i class="fas fa-chevron-down"></i>';

                        // Reset chevron rotation
                        const chevron = toggleButton.querySelector("i");
                        chevron.style.transform = "rotate(0deg)";

                        showingMore = false;
                    } else {
                        toggleButton.style.display = "none";
                    }

                    // After the content is updated, scroll to maintain the grid position
                    setTimeout(() => {
                        // Get new position of grid and scroll to maintain the same relative position
                        const newGridTop = grid.getBoundingClientRect().top;
                        const scrollAdjustment =
                            newGridTop - gridTopRelativeToViewport;

                        // Smooth scroll to adjusted position
                        window.scrollTo({
                            top: window.scrollY + scrollAdjustment,
                            behavior: "smooth",
                        });
                    }, 50); // Short delay to ensure DOM has updated
                }, 300); // Delay to match the fade out transition
            }, 300); // Debounce delay
        });
    }

    // Handle tag filtering
    tags.forEach((tag) => {
        tag.addEventListener("click", () => {
            // Save current scroll position relative to the grid
            const gridTopRelativeToViewport = grid
                ? grid.getBoundingClientRect().top
                : 0;

            // Update active state
            tags.forEach((t) => t.classList.remove("active"));
            tag.classList.add("active");

            // Apply filter
            const filter = tag.dataset.filter;
            const filtered =
                filter === "all"
                    ? legends
                    : legends.filter((l) => l.field === filter);

            // Apply fade out effect before updating content
            if (grid) {
                grid.style.opacity = "0";
                grid.style.transform = "translateY(20px)";

                setTimeout(() => {
                    // Reset displayed count to initial when changing categories
                    displayed = initialDisplayCount;
                    showingMore = false;

                    // Update display
                    renderLegends(filtered.slice(0, displayed));

                    // Fade in the new content
                    grid.style.opacity = "1";
                    grid.style.transform = "translateY(0)";

                    // Update toggle button visibility and state
                    if (filtered.length > displayed) {
                        toggleButton.style.display = "block";
                        toggleButton.innerHTML =
                            '<span>Show More</span> <i class="fas fa-chevron-down"></i>';
                    } else {
                        toggleButton.style.display = "none";
                    }

                    // After the content is updated, scroll to maintain the grid position
                    setTimeout(() => {
                        // Get new position of grid and scroll to maintain the same relative position
                        const newGridTop = grid.getBoundingClientRect().top;
                        const scrollAdjustment =
                            newGridTop - gridTopRelativeToViewport;

                        // Smooth scroll to adjusted position
                        window.scrollTo({
                            top: window.scrollY + scrollAdjustment,
                            behavior: "smooth",
                        });
                    }, 50); // Short delay to ensure DOM has updated
                }, 300); // Delay to match the fade out transition
            }
        });
    });

    // Handle toggle button click
    toggleButton.addEventListener("click", () => {
        // Save current scroll position and position of toggle button before animation
        const scrollPosition = window.scrollY;
        const toggleButtonPosition =
            toggleButton.getBoundingClientRect().top + window.scrollY;

        // Get currently active filter
        const activeFilter =
            document.querySelector(".tag.active").dataset.filter;

        // Get filtered items based on search and active filter
        const query = search.value.toLowerCase();
        let filtered = legends;

        // Apply search filter
        if (query) {
            filtered = filtered.filter(
                (l) =>
                    l.name.toLowerCase().includes(query) ||
                    l.field.toLowerCase().includes(query),
            );
        }

        // Apply tag filter
        if (activeFilter !== "all") {
            filtered = filtered.filter((l) => l.field === activeFilter);
        }

        // Apply fade out effect
        grid.style.opacity = "0";
        grid.style.transform = "translateY(20px)";

        // Toggle between show more and show less
        setTimeout(() => {
            if (!showingMore) {
                // Show more - display all filtered items
                // If "All" category is selected, show all characters at once
                if (activeFilter === "all") {
                    displayed = filtered.length; // Show all items for the "All" category
                } else {
                    displayed = Math.min(
                        filtered.length,
                        initialDisplayCount + 9,
                    ); // Show up to 9 more items for other categories
                }

                toggleButton.innerHTML =
                    '<span>Show Less</span> <i class="fas fa-chevron-up"></i>';

                // Add rotation animation to the chevron
                const chevron = toggleButton.querySelector("i");
                chevron.style.transition = "transform 0.5s ease";
                chevron.style.transform = "rotate(180deg)";

                showingMore = true;

                // Hide button if we're showing all items
                if (displayed >= filtered.length) {
                    toggleButton.innerHTML =
                        '<span>Show Less</span> <i class="fas fa-chevron-up"></i>';
                }
            } else {
                // Show less - reset to initial count
                displayed = initialDisplayCount;
                toggleButton.innerHTML =
                    '<span>Show More</span> <i class="fas fa-chevron-down"></i>';

                // Add rotation animation to the chevron
                const chevron = toggleButton.querySelector("i");
                chevron.style.transition = "transform 0.5s ease";
                chevron.style.transform = "rotate(0deg)";

                showingMore = false;
            }

            // Update display with animation
            renderLegends(filtered.slice(0, displayed));

            // Fade in updated content
            grid.style.opacity = "1";
            grid.style.transform = "translateY(0)";

            // Hide button if no more items to show or if we're showing all and there are no more
            if (!showingMore && filtered.length <= displayed) {
                toggleButton.style.display = "none";
            }

            // After content is updated, determine new position to scroll to
            setTimeout(() => {
                // Determine new position to scroll to
                let newScrollPosition;

                if (showingMore) {
                    // When showing more, keep the button in the same relative position on screen
                    const newTogglePosition =
                        toggleButton.getBoundingClientRect().top +
                        window.scrollY;
                    const offset = newTogglePosition - toggleButtonPosition;

                    // Adjust scroll position to maintain the same relative position of the button
                    newScrollPosition = scrollPosition + offset;
                } else {
                    // When showing less, scroll to the top of the grid
                    newScrollPosition =
                        grid.getBoundingClientRect().top + window.scrollY - 20;
                }

                // Smooth scroll to new position
                window.scrollTo({
                    top: newScrollPosition,
                    behavior: "smooth",
                });
            }, 50); // Short delay to ensure DOM has updated
        }, 300);
    });

    // Render legend items to the grid with staggered animation
    function renderLegends(items) {
        grid.innerHTML = items
            .map(
                (l, index) => `
            <div class="legend" data-field="${l.field}" style="animation: fadeInUp 0.5s ease forwards; animation-delay: ${index * 0.05}s; opacity: 0; transform: translateY(20px);">
                <div class="legend-image">
                    <img src="${l.image}" alt="${l.name}">
                </div>
                <h3>${l.name}</h3>
                <p>${l.tagline}</p>
                <a href="#" class="chat-btn" onclick="selectCharacter('${l.id}'); return false;">Chat Now</a>
            </div>
        `,
            )
            .join("");

        // Add the animation keyframes to the document if not already present
        if (!document.getElementById("legend-animations")) {
            const styleSheet = document.createElement("style");
            styleSheet.id = "legend-animations";
            styleSheet.textContent = `
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `;
            document.head.appendChild(styleSheet);
        }
    }
});
